import React, { useState } from 'react';
import { Avatar } from 'antd';

const UserProfileImage = ({ id, className, uri, name, color }) => {
  if (uri) {
    return (
      <span className={`ant-avatar ${className}`}>
        <img src={`${process.env.REACT_APP_API_URL}/${uri}`} alt="Avatar" />
      </span>
    );
  }

  if (id) {
    return (
      <Avatar
        className={className}
        src={`${process.env.REACT_APP_API_URL}/users/${id}/image`}
      />
    );
  }

  if (name) {
    const colorIndex = Math.floor(Math.random() * 4);

    const initials = name
      .split(' ')
      .filter((word) => word.length !== 2)
      .filter((_, index) => index <= 1)
      .map((n) => n[0])
      .join('')
      .toUpperCase();

    return (
      <Avatar className={className} style={{ backgroundColor: '#f56a00' }}>
        {initials}
      </Avatar>
    );
  }

  return null;
};

export default UserProfileImage;
